import React, { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ScrollPanel } from 'primereact/scrollpanel';
import useWindowDimensions from '../hooks/useDimensions';
import { positions, style } from '@mui/system';
import axios from 'axios';
import apis from '../../api';
import fileToBase64 from '../../services/fileToBase64';
import Base64Downloader from 'common-base64-downloader-react';
import { Dialog } from 'primereact/dialog';
import { PDFDocument } from 'pdf-lib';
import PhoneAuth from '../../helpers/PhoneAuth';
import { Badge } from 'primereact/badge';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const SignDocument = () => {
    const [file, setFile] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const canvasRef = useRef([]);
    const fileUploadRef = useRef(null);
    const toast = useRef(null);

    const { width, height } = useWindowDimensions()

    const [image, setImage] = useState(null);
    const [draggedImage, setDraggedImage] = useState(null);
    const [imagePosition, setImagePosition] = useState(null); // Store image position
    const imageUploadRef = useRef(null);

    const [sendFile, setSendFile] = useState("")
    const [sendImage, setSendImage] = useState("")
    const [ciudad, setCiudad] = useState("")
    const [pais, setPais] = useState("")
    const [signedFile, setSignedFile] = useState("")
    const [fileName, setFileName] = useState("")

    const [loading, setLoading] = useState(false)
    const [isOpen, setIsOpen] = useState(false);

    const { phone, setPhone, otp, setOtp, confirmation, setConfirmation, sendOtp, verifyOtp, toastOtp, isOpenOtp, setIsOpenOtp,
        mailConfirmation, setMailConfirmation, mailOtp, setMailOtp, verifyMailOtp, sendMailOtp, loadVerify, setLoadVerify, loadOtp, setLoadOtp, isValid, setIsValid, captchaKey
    } = PhoneAuth()

    const [mailChecked, setMailChecked] = useState(false)
    const [phoneChecked, setPhoneChecked] = useState(false)
    const [warnMsg, setWarnMsg] = useState("")

    const headers = {
        authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json; charset=UTF-8'
    }

    // mostrar modal
    const showModal = () => {
        setIsOpen(true);
    };

    // ocultar modal
    const hideModal = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        handleLocation()
    }, [])

    function handleLocation() {
        if (navigator.geolocation) {
            try{
                navigator.geolocation.getCurrentPosition(success, error);
            }
            catch(err){
                console.log(err)
            }
        } else {
            console.log("Geolocation not supported");
        }
    }

    async function success(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        console.log(latitude, longitude)
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GEO}`;

        try {
            const response = await axios.get(url);
            const results = response.data.results;
            console.log(results)
            if (results.length > 0) {
                const addressComponents = results[0].address_components;
                const countryComponent = addressComponents.find(component =>
                    component.types.includes('country')
                );
                const cityComponent = addressComponents.find(component =>
                    component.types.includes('locality') || component.types.includes('administrative_area_level_2')
                );
                console.log(countryComponent)
                console.log(cityComponent)
                if (countryComponent) {
                    setPais(countryComponent.long_name);
                }
                if (cityComponent) {
                    setCiudad(cityComponent.long_name)
                }
            }
        } catch (error) {
            console.error('Error fetching the country name:', error);
        }
        console.log(position)

    }

    function error() {
        console.log("No se puede obtener la localizacion");
    }

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const getImageDimensions = (blobUrl) => {
        console.log(blobUrl)
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                // The image is loaded, now you can access its width and height
                const width = img.width;
                const height = img.height;
                console.log(width, height)
                resolve({ width, height });
            };

            img.onerror = reject;

            // Set the image src to the Blob URL
            img.src = blobUrl;
        });
    };

    const drawImageOnCanvas = (x, y, pageIndex) => {
        if (!image) return;
        const res = getImageDimensions(image.src).then(({ width, height }) => {
            console.log(res)
            const canvas = canvasRef.current[pageIndex];
            const ctx = canvas.getContext('2d');
            if (width > 150 || height > 150) {
                const aspectRatio = width / height;

                if (width > height) {
                    width = 150;
                    height = width / aspectRatio;
                } else {
                    height = 150;
                    width = height * aspectRatio;
                }
            }
            ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas before drawing
            ctx.drawImage(image, x, y, width, height); // Adjust the size as needed
            setImagePosition({ x, y, pageIndex }); // Store the position after drawing
        })
    };

    const handleCanvasDragOver = (e) => {
        e.preventDefault();
    };

    const handleCanvasDrop = (e, pageIndex) => {
        e.preventDefault();
        if (!draggedImage) return;
        const canvas = canvasRef.current[pageIndex];
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        drawImageOnCanvas(x, y, pageIndex);
    };

    const undoImageDrop = () => {
        if (imagePosition) {
            const { pageIndex } = imagePosition;
            const canvas = canvasRef.current[pageIndex];
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas to remove the image
            setImagePosition(null); // Reset the position to allow re-dropping
        }
        setImagePosition(null)
    };

    const onTemplateSelect = (e) => {
        let files = e.files;
        if (files.length > 0) {
            const fileUrl = URL.createObjectURL(files[0]);
            setSendFile(files[0])
            setFile(fileUrl);
        }
    };

    const onTemplateRemove = (file, callback) => {
        setFile(null);
        callback();
    };

    const onTemplateClear = () => {
        setFile(null);
        setImagePosition(null)
    };

    const onImageTemplateSelect = (e) => {
        let files = e.files;
        if (files.length > 0) {
            const img = new Image();
            img.src = URL.createObjectURL(files[0]);
            img.onload = () => setImage(img);
            setSendImage(files[0])
        }
    };

    const onImageTemplateRemove = (file, callback) => {
        setImage(null);
        setDraggedImage(null)
        setImagePosition(null); // Clear the image position when removing the image
        callback();
    };

    const onImageTemplateClear = () => {
        setImage(null);
        setDraggedImage(null)
        setImagePosition(null); // Clear the image position when clearing the image
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {cancelButton}
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-upload', iconOnly: false, className: 'custom-choose-btn p-button-rounded', style: { width: '10rem' } };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: false, className: 'custom-cancel-btn p-button-danger p-button-rounded', style: { width: '10rem' } };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                    </span>
                </div>
            </div>
        );
    };

    const itemImageTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100}
                        draggable
                        onDragStart={() => setDraggedImage(image)}
                        style={{ width: '100px', cursor: 'pointer' }} />
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                    </span>
                </div>
            </div>
        );
    };

    const exportPdfWithImageToBase64 = async () => {
        const existingPdfBytes = await fetch(file).then(res => res.arrayBuffer()); // Load the original PDF file

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const pages = pdfDoc.getPages();

        const canvases = canvasRef.current;

        // Iterate through each canvas (page) and add the drawn images to the PDF
        for (let index = 0; index < canvases.length; index++) {
            const canvas = canvases[index];
            const ctx = canvas.getContext('2d');

            // Convert canvas to image data URL
            const imageDataUrl = canvas.toDataURL('image/png');

            // Embed the image into the PDF
            const page = pages[index];
            const imgData = await pdfDoc.embedPng(imageDataUrl);

            // Draw the image on the PDF page (adjust x, y, width, height as needed)
            console.log(imagePosition)
            page.drawImage(imgData, {
                x: 0,
                y: page.getHeight() - 842,
                width: 595,
                height: 842,
            });
        }

        // Serialize the PDF document to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save();

        // Convert PDF to base64
        let base64Pdf = btoa(
            pdfBytes.reduce((data, byte) => data + String.fromCharCode(byte), '')
        );
        base64Pdf = 'data:application/pdf;base64,' + base64Pdf
        // console.log(base64Pdf)
        setFileName(sendFile.name)
        return base64Pdf;
    };

    const signFile = async () => {
        setLoading(true)
        const base64file = await exportPdfWithImageToBase64()
        let base64Image = ""

        // let reader = new FileReader();
        // const data = await fetch(file)
        // const blob = await data.blob()
        // console.log(data)
        // reader.readAsDataURL(blob);
        // reader.onloadend = function () {
        //     base64file = reader.result;
        //     console.log(base64file);
        // }

        // await fileToBase64(sendFile).then(res => {
        //     setFileName(sendFile.name)
        //     base64file = res
        // })
        await fileToBase64(sendImage).then(res => {
            base64Image = res
        })

        let date = (new Date(Date.now())).toLocaleString('es-CO').toString()
        console.log(pais)
        console.log(pais.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
        let newDate = ""
        for (let i = 0; i < date.length; i++) {
            if (date.charCodeAt(i) <= 127) {
                newDate += date.charAt(i);
            }
        }

        const document = {
            "/Pais": pais.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            "/Ciudad": ciudad.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
            "/Usuario": localStorage.getItem('user'),
            "/Aplicacion": "Remuner BPO",
            "/Responsable": "Remuner",
            "/Fecha": newDate
        }

        const payload = {
            PARAMS: [{
                FILE: base64file,
                DOCUMENT: document,
            }]
        }

        try {
            await apis.documentSignature(payload, headers).then(res => {
                setSignedFile(res.data.FILE)
                showModal()
                setLoading(false)
            })
            // await apis.pythonTest(payload, 'PDF.FirmDocument').then(res => {
            //     setSignedFile(res.data.FILE)
            //     showModal()
            //     setLoading(false)
            // })
        }
        catch (err) {
            console.log(err)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading(false)
        }
    }

    const handleCheckboxChange = (checked, value) => {
        console.log(value, checked)
        if (value === 'MAIL') {
            setMailChecked(checked)
            if (checked) {
                if (phoneChecked) {
                    setPhoneChecked(!checked)
                }
            }
        }
        else if (value === 'PHONE') {
            setPhoneChecked(checked)
            if (checked) {
                if (mailChecked) {
                    setMailChecked(!checked)
                }
            }
        }
        // Actualizar el estado del checkbox correspondiente
        // value === 'MAIL' ? setMailChecked(checked) : setPhoneChecked(checked);
    };


    const getPhone = async () => {
        setLoading(true)
        try {
            await apis.getIdentity(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('number_id'), localStorage.getItem('token'), headers).then(res => {
                let data = res.data.PERSON[0]
                setPhone(data.CELL_PHONE1 ? data.CELL_PHONE1 : "")
                setWarnMsg(data.CELL_PHONE1 ? "" : "La opción de solicitar el código mediante teléfono no se encuentra habilitada debido a que no cuentas con un número de teléfono registrado. Por favor comunicáte con gestión humana")
                setIsOpenOtp(true)
            })
        }
        catch (err) {
            console.log(err)
        }
        finally{
            setLoading(false)
        }
    }
    
    const otpFooter = (
        <div>
            <Button onClick={() => { setIsOpenOtp(false); clear() }} label='Cancelar'></Button>
            {isValid && <Button loading={loading} className='custom-cancel-btn p-button-success p-button-rounded mt-1' label="Firmar" icon="pi pi-check" onClick={signFile} />}
        </div>
    );

    const clear = () => {
        setOtp("")
        setMailOtp("")
        setConfirmation(null)
        setMailConfirmation(false)
        setIsValid(false)
        setMailChecked(false)
        setPhoneChecked(false)
        setPhone("")
    }


    return (
        <div className="flex flex-wrap align-items-center justify-content-center card-container yellow-container flex-column color-blue">
            <div style={{ marginBottom: "2rem", marginTop: "5rem" }} className="mb-3 font-bold text-4xl flex justify-content-center align-items-center">
                <span className="text-900">Firma digital</span>
            </div>
            <div className='flex flex-row scrollpanel-demo justify-content-between' style={{ width: '100%' }}>
                <div className='ml-4'>
                    <Toast ref={toast} />
                    <Dialog visible={isOpen} header={"Descargar documento firmado"}
                        position="top" draggable={false} resizable={false} modal onHide={hideModal}>
                        <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={"data:application/pdf;base64," + signedFile} downloadName={fileName.split('.')[0] + "_firmado"} onDownloadSuccess={() => { hideModal() }}>
                            <Button icon="pi pi-download" label='Descargar' />
                        </Base64Downloader>
                    </Dialog>
                    <Dialog visible={isOpenOtp} header={"Autenticación de dos pasos"} footer={otpFooter}
                        position="top" draggable={false} resizable={false} modal onHide={() => { setIsOpenOtp(false); clear() }}>
                        <Toast ref={toastOtp} />
                        <span>Seleccione el medio por el cual desea recibir el código de verificación:</span><br /><br />
                        <div className="flex flex-wrap justify-content-start gap-2">
                            <div className="flex align-items-center">
                                <Badge className="ml-2 mr-1" value="Correo" size="medium" severity="info" />
                                <Checkbox inputId="IN" value="MAIL" className='check-in' onChange={(e) => {
                                    handleCheckboxChange(e.checked, e.value)
                                }}
                                    checked={mailChecked} />
                            </div>
                            <div className="flex align-items-center">
                                <Badge className="ml-1 mr-1" value="Teléfono" size="medium" severity="info" />
                                <Checkbox inputId="OUT" value="PHONE" className='check-out' onChange={(e) => {
                                    handleCheckboxChange(e.checked, e.value)
                                }} disabled={!phone}
                                    checked={phoneChecked} />
                            </div>
                            {(phoneChecked || mailChecked) &&
                                <Button onClick={phoneChecked ? sendOtp : sendMailOtp} loading={loadOtp} label='Solicitar código' disabled={!phoneChecked && !mailChecked}
                                    className="p-1 flex align-items-center justify-content-center border-none p-button-sm" size='small'
                                >
                                    {/* <Badge value="Solicitar código" size="large" severity="info" /> */}
                                </Button>
        
                            }
                            {!phone && <span><span className='font-bold'>Nota: </span>{warnMsg}</span>}
                        </div><br />
                        {(phoneChecked || mailChecked) &&
                            <>
                                <div id="recaptcha-container" key={captchaKey}></div>
                                {confirmation && (
                                    <>
                                        <InputText
                                            type="text"
                                            placeholder="Ingrese el código"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}
                                        />{" "}
                                        <Button onClick={verifyOtp} loading={loadVerify} label="Verificar código" />
                                    </>
                                )}
                                {mailConfirmation && (
                                    <>
                                        <InputText
                                            type="text"
                                            placeholder="Ingrese el código"
                                            value={mailOtp}
                                            onChange={(e) => setMailOtp(e.target.value)}
                                        />{" "}
                                        <Button onClick={verifyMailOtp} loading={loadVerify} label="Verificar código" />
                                    </>
                                )}
                            </>}
                    </Dialog>
                    <span className="text-900 font-bold text-xl">Documento</span>
                    <br />
                    <FileUpload className='card'
                        name="demo[]" ref={fileUploadRef} accept="application/pdf" maxFileSize={2000000} chooseLabel="Seleccionar" cancelLabel='Cancelar'
                        onValidationFail={() => {
                            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                        }}
                        onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear}
                        headerTemplate={headerTemplate} itemTemplate={itemTemplate}
                        chooseOptions={chooseOptions} cancelOptions={cancelOptions}
                    />
                    <br />
                    <span className="text-900 font-bold text-xl">Firma</span>
                    <br />
                    <FileUpload className='card'
                        name="demo[]" ref={imageUploadRef} accept="image/*" maxFileSize={2000000} chooseLabel="Seleccionar" cancelLabel='Cancelar'
                        onValidationFail={() => {
                            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                        }}
                        onSelect={onImageTemplateSelect} onError={onImageTemplateClear} onClear={onImageTemplateClear}
                        headerTemplate={headerTemplate} itemTemplate={itemImageTemplate}
                        chooseOptions={chooseOptions} cancelOptions={cancelOptions}
                    />
                    {imagePosition && (
                        <div style={{ marginTop: "1rem" }}>
                            <Button disabled={!draggedImage || !file} loading={loading} className='custom-cancel-btn p-button-success p-button-rounded mt-1' label="Firmar" icon="pi pi-check" onClick={getPhone} />
                            <Button className='custom-cancel-btn p-button-danger p-button-rounded mt-1' label="Deshacer firma" icon="pi pi-undo" onClick={undoImageDrop} />
                        </div>
                    )}
                </div>
                <ScrollPanel
                    className="custombar1"
                    style={{
                        // ...(open ? styleOpen : styleClose),
                        marginTop: '1rem',
                        marginLeft: '1rem',
                        height: '80vh',
                        width: width >= 1024 ? '33vw' : '60vw',
                        textAlign: 'left !important',
                        backgroundColor: 'white'
                        // display: 'flex',
                        // flexWrap: 'wrap'
                    }}>
                    {file && <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                        {Array.from({ length: numPages }, (el, index) => (
                            <div key={`page_${index + 1}`} style={{ position: 'relative' }}>
                                <Page pageNumber={index + 1} renderTextLayer={false} />
                                <canvas
                                    ref={(el) => (canvasRef.current[index] = el)}
                                    style={{ position: 'absolute', top: 0, left: 0 }}
                                    width={595}
                                    height={842}
                                    onDragOver={handleCanvasDragOver}
                                    onDrop={(e) => handleCanvasDrop(e, index)}
                                />
                                <br />
                            </div>
                        ))}
                    </Document>}
                </ScrollPanel>
                {width >= 1024 && <video src='https://remuner.s3-us-east-2.amazonaws.com/fuentes/firma/Firma.mp4'
                    style={{
                        width: width * 0.4,
                        height: height * 0.6
                    }}
                    autoPlay
                    muted loop />}
            </div>
        </div>
    );
};

export default SignDocument;
